var _excluded = ["title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgAssignment = function SvgAssignment(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Assignment' : _ref$title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 47C11.3 47 1 36.7 1 24S11.3 1 24 1s23 10.3 23 23-10.3 23-23 23zm0-1.84c11.7 0 21.16-9.47 21.16-21.16C45.16 12.3 35.7 2.84 24 2.84 12.3 2.84 2.84 12.3 2.84 24c0 11.7 9.47 21.16 21.16 21.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 19h-8v-8H18v4h-2V9h14.4l7.6 7.6V37h-6v-2h4V19zm-.4-2L30 11.4V17h5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 30c-2.16 0-3.6-1.17-4.35-3.13-.5-1.3-.65-2.74-.65-4.6 0-2.9 2.22-5.27 5-5.27s5 2.37 5 5.26c0 1.87-.16 3.3-.65 4.6C24.6 28.84 23.15 30 21 30zm0-2c2.24 0 3-2 3-5.74 0-1.8-1.36-3.26-3-3.26s-3 1.45-3 3.26C18 26 18.76 28 21 28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 37h14v-2.03c0-.32-.4-.74-1.53-1.16-1.36-.5-3.33-.8-5.47-.8-2.12 0-4.1.3-5.47.83-1.12.43-1.53.85-1.53 1.14V37zm-2-2.03c0-2.73 4.5-3.97 9-3.97s9 1.18 9 3.97V39H12v-4.03z"
  }));
};
SvgAssignment = pure(SvgAssignment);
SvgAssignment.displayName = 'SvgAssignment';
export default SvgAssignment;